import '@fancyapps/fancybox/dist/jquery.fancybox.min';
import Modernizr from 'modernizr';
import LazyLoad from "vanilla-lazyload";
import 'jquery-match-height/dist/jquery.matchHeight-min';
import Paroller from 'paroller.js';


export class UxCpnt {
    constructor()
    {
        this.initializeJsClick();
        this.initializeBootstrpTooltip();
        this.initializeFancybox();
        this.initializeSearchBox();
        this.initializeBackToTop();
        this.initializeSmoothScroll();
        this.initializeLazy();
        this.initializeOnScroll();
        this.initializeVideoGutenberg();
        this.initializeLastBlock();
        this.initializeParoller();
        this.initializeMatchHeight();
        this.initializeHoverPostHighlight();
        this.initializeAgendaLink();
        this.initializeInstagram();
        this.initializeSvgMap();
        this.initializeBurgerMenu();
        this.initializeLang();
        this.initializeCookieOptIn();
    }
    
    initializeJsClick()
    {
        if ( !Modernizr.touchevents ) {
            let ctrl = 0;
            $( window ).on( 'keydown', function ( e ) {
                if ( e.which == 17 || e.which == 91 ) {
                    
                    ctrl = true;
                }
            } );
            
            $( window ).on( 'keyup', function () {
                ctrl = false;
            } );
            
            $( document ).on( 'mouseup', '.js-click', function ( e ) {
                
                if ( e.which == 1 || e.which == 2 ) {
                    let blank = false;
                    let url   = $( this ).find( "a" ).attr( "href" );
                    if ( e.which == 2 ) {
                        blank = true;
                    } // Clic molette
                    if ( $( this ).find( "a" ).attr( "target" ) == "_blank" ) {
                        blank = true;
                    }
                    if ( blank || ctrl ) {
                        window.open( url, '_blank' );
                    } else {
                        window.location = url;
                    }
                    return false;
                }
                return false;
                
            } );
        } else {
            $( document ).on( 'click', '.js-click', function ( e ) {
                
                let blank = false;
                let url   = $( this ).find( "a" ).attr( "href" );
                if ( $( this ).find( "a" ).attr( "target" ) == "_blank" ) {
                    blank = true;
                }
                if ( blank ) {
                    window.open( url, '_blank' );
                } else {
                    window.location = url;
                }
                return false;
                
            } );
        }
    }
    
    initializeBootstrpTooltip()
    {
        if ( !Modernizr.touchevents ) {
            $( '[data-toggle="tooltip"], [rel="tooltip"]' ).tooltip( { trigger: "hover" } );
        }
    }
    
    initializeFancybox()
    {
        
        $( '.article a:has(>img):not([target="_blank"]):not(".no-fancybox")' ).attr( 'data-fancybox', 'fancybox' );
        
        $( "[data-fancybox='fancybox']" ).fancybox( {
                                                        buttons: [
                                                            "zoom",
                                                            //"share",
                                                            "slideShow",
                                                            //"fullScreen",
                                                            //"download",
                                                            //"thumbs",
                                                            "close"
                                                        ],
                                                        lang: "fr",
                                                        i18n: {
                                                            fr: {
                                                                CLOSE: Theme.translate.fancyboxClose,
                                                                NEXT: Theme.translate.fancyboxNext,
                                                                PREV: Theme.translate.fancyboxPrev,
                                                                ERROR: Theme.translate.fancyboxError,
                                                                PLAY_START: Theme.translate.fancyboxStart,
                                                                PLAY_STOP: Theme.translate.fancyboxStop,
                                                                FULL_SCREEN: Theme.translate.fancyboxFullScreen,
                                                                THUMBS: Theme.translate.fancyboxThumbs,
                                                                DOWNLOAD: Theme.translate.fancyboxDownload,
                                                                SHARE: Theme.translate.fancyboxShare,
                                                                ZOOM: Theme.translate.fancyboxZoom
                                                            },
                                                        },
                                                        caption: function ( instance, item ) {
                                                            let caption = $( this ).closest( 'figure' ).find( 'figcaption' ).html();
                
                                                            if ( !caption ) {
                                                                caption = $( this ).find( 'img' ).attr( 'title' );
                                                            }
                
                                                            if ( !caption ) {
                                                                caption = $( this ).find( 'img' ).attr( 'alt' );
                                                            }
                
                                                            return caption;
                                                        }
                                                    } );
    }
    
    initializeCookieOptIn()
    {
        tarteaucitron.init( {
                                "useExternalCss": false,
                                "privacyUrl": Theme.privacyPolicyURL,
            
                                "hashtag": "",
                                "cookieName": "tartaucitron",
            
                                "orientation": "bottom",
                                "showAlertSmall": false,
                                "cookieslist": true,
            
                                "adblocker": false,
                                "AcceptAllCta": true,
                                "highPrivacy": true,
                                "handleBrowserDNTRequest": false,
            
                                "removeCredit": true,
                                "moreInfoLink": true,
                                "showExitButton": true
                            } );
        
        tarteaucitronForceLanguage = Theme.current_locale;
        (tarteaucitron.job = tarteaucitron.job || []).push( 'wordpress' );
        (tarteaucitron.job = tarteaucitron.job || []).push( 'recaptcha' );
        (tarteaucitron.job = tarteaucitron.job || []).push( 'gtag' );
    }
    
    initializeSearchBox()
    {
        $( '.js-wpSearchLayoutOpen' ).on( 'click', function ( e ) {
            e.preventDefault();
            $( '.wpSearchLayout' ).fadeIn();
            setTimeout( function () {
                $( '.wpSearchFormItem--input' ).focus();
            }, 100 );
        } );
        
        $( '.js-wpSearchLayoutClose' ).on( 'click', function ( e ) {
            e.preventDefault();
            $( '.wpSearchLayout' ).fadeOut();
        } );
    }
    
    initializeBackToTop()
    {
        $( '.js-backToTop' ).on( 'click', function ( e ) {
            e.preventDefault();
            
            if ( $( window ).scrollTop() != 0 ) {
                $( 'html, body' ).animate( { scrollTop: 0 }, 300 );
            }
        } );
        
        $( window ).on( 'scroll', function ( e ) {
            
            if ( $( this ).scrollTop() > 250 ) {
                $( '.js-backToTop' ).addClass( 'backToTop--show' );
            } else {
                $( '.js-backToTop' ).removeClass( 'backToTop--show' );
            }
        } );
    }
    
    initializeSmoothScroll()
    {
        $( '.js-scroll' ).click( function () {
            if ( location.pathname.replace( /^\//, '' ) == this.pathname.replace( /^\//, '' ) && location.hostname == this.hostname ) {
                let target = $( this.hash );
                target     = target.length ? target : $( '[name=' + this.hash.slice( 1 ) + ']' );
                if ( target.length ) {
                    $( 'html,body' ).animate( {
                                                  scrollTop: target.offset().top
                                              }, 750 );
                    return false;
                }
            }
        } );
    }
    
    initializeLazy()
    {
        let lazyLoadInstance = new LazyLoad( {
                                                 elements_selector: "[data-src], [data-bg]"
                                             } );
    }
    
    initializeOnScroll()
    {
        
        let last_scroll_top = 0;
        $( window ).on( 'load scroll', function () {
            
            let scroll_top = $( this ).scrollTop();
            let $header    = $( '.header' );
            
            if ( scroll_top >= last_scroll_top && scroll_top > 100 ) {
                // Down
                $( 'body' ).addClass( 'header-is-hidden' );
            } else {
                // Up
                $( 'body' ).removeClass( 'header-is-hidden' );
            }
            
            last_scroll_top = scroll_top;
            
            // Site header color
            if ( $( '.header-is-transparent' ).length ) {
                
                let height_banner = ($( '[data-banner]' ).outerHeight() - $( '.header' ).outerHeight());
                
                if ( scroll_top > 100 ) {
                    $header.removeClass( 'header--transparent' );
                } else {
                    $header.addClass( 'header--transparent' );
                }
            }
        } );
    }
    
    initializeVideoGutenberg()
    {
        var block  = '.wp-block-video',
            $video = $( '.wp-block-video video' );
        
        if ( $video.length > 0 ) {
            $video.on( 'click', function ( e ) {
                e.preventDefault();
                
                var video = this;
                
                if ( video.paused ) {
                    video.play();
                } else {
                    video.pause();
                }
            } );
            $video.each( function () {
                
                var video = this;
                
                $( video ).on( 'ended', function () {
                    // video.controls = false;
                    // video.currentTime = 0;
                    $( video ).parent().removeClass( 'is-playing' );
                } );
                
                $( video ).on( 'playing', function () {
                    // video.controls = true;
                    $( video ).parent().addClass( 'is-playing' );
                } );
                
                $( video ).on( 'pause', function () {
                    $( video ).parent().removeClass( 'is-playing' );
                    // video.controls = false;
                } );
            } );
        }
    }
    
    initializeLastBlock()
    {
        if ( $( '.page-template-default .article > .relatedpost, .post-template-default .article > .relatedpost' ).length > 0 ) {
            $( '.article > *:last-child' ).addClass( 'lastblock' );
        }
    }
    
    initializeParoller()
    {
        if ( window.matchMedia( "(min-width: 959px)" ).matches ) {
            $( '[data-paroller]' ).paroller();
        }
        
    }
    
    initializeMatchHeight()
    {
        let $item = $( '[data-mh]' );
        
        if ( $item.length > 0 ) {
            
            $item.matchHeight( { property: 'min-height' } );
            
        }
    }

    initializeAgendaLink()
    {
        $( '[data-link-agenda]' ).on( 'click', function ( e ) {
            console.log( 'test' );
            e.preventDefault();
            var rel = $( this ).attr( 'rel' );
            $( '#datedebutlisting_18' ).val( rel );
            $( '#agendaHomeForm' ).submit();
        } );
    }
    
    initializeHoverPostHighlight()
    {
        let $wrapper = $( '.posthighlightList' ),
            $first   = $( '.posthighlightItem--first' ),
            $item    = $( '.posthighlightItem' );
        
        if ( $wrapper.length > 0 ) {
            
            $item.hover(
                function () {
                    $item.removeClass( "active" );
                    $( this ).addClass( "active" );
                }, function () {
                    $item.removeClass( "active" );
                    $( '.posthighlightItem--first' ).addClass( "active" );
                }
            );
            
        }
    }
    
    initializeInstagram()
    {
        
        if ( $( '.strateInstagram' ).length > 0 ) {
            self = this;
            $.ajax( {
                        url: Theme.ajaxURL,
                        data: {
                            'action': 'social_wall',
                        },
                        type: 'POST',
                        success: function ( socialData ) {
                            $( '.strateInstagram' ).append( socialData );
                            self.initializeLazy();
                            self.initializeBootstrpTooltip();
                        }
                    } );
        }
    }
    
    initializeSvgMap()
    {
        
        if ( $( '.strateMap' ).length > 0 ) {
            let $item = $( '.mapItem' ),
                $city = $( '.svgMapCity' );
            
            $city.hover(
                function () {
                    let id = $( this ).attr( 'id' );
                    $( '[data-city]' ).removeClass( 'active' );
                    $( '[data-city=' + id + ']' ).addClass( 'active' );
                }, function () {
                    $( '[data-city]' ).removeClass( 'active' );
                    $( '[data-city=montreuil]' ).addClass( 'active' );
                }
            );
        }
    }
    
    initializeBurgerMenu()
    {
        let more_menu   = '[data-more-menu]',
            item_menu   = '[data-item-menu]',
            return_menu = '[data-return-menu]',
            nav_menu    = '[data-nav-menu]',
            burger_menu = '[data-burger-menu]';
        
        $( document ).on( 'click', more_menu, function ( e ) {
            $( item_menu ).removeClass( 'submenuActive' );
            $( this ).parents( item_menu ).addClass( 'submenuActive' );
        } );
        
        $( document ).on( 'click', return_menu, function ( e ) {
            $( this ).parents( item_menu ).removeClass( 'submenuActive' );
        } );
        
        $( document ).on( 'click', burger_menu, function ( e ) {
            $( 'body' ).toggleClass( 'menuOpen' );
            $( this ).toggleClass( 'open' );
            $( item_menu ).removeClass( 'submenuActive' );
        } );
    }
    
    initializeLang()
    {
        function getCookie( cname )
        {
            var name = cname + "=";
            var ca   = document.cookie.split( ';' );
            for ( var i = 0; i < ca.length; i++ ) {
                var c = ca[ i ].trim();
                if ( c.indexOf( name ) == 0 ) {
                    return c.substring( name.length, c.length );
                }
            }
            return "";
        }
        
        let current_lang = getCookie( 'googtrans' );
        let lang_item    = '[data-lang]';
        $( document ).on( 'click', lang_item, function () {
            let value = $( this ).html();
            $( '.langItem' ).removeClass( 'active' );
            $( this ).parent().addClass( 'active' );
            $( '.langCurrent' ).html( value );
        } );
        
    }
    
}
